// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgSofaBed = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill={color}
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.374 3.625c.76 0 1.375.616 1.375 1.375v4.875h.5c.174 0 .34.024.501.065v-.565a.75.75 0 1 1 1.499 0v4.375c0 .76-.615 1.374-1.374 1.374h-1.126v.501a.75.75 0 1 1-1.499 0v-.5H5.749v.5a.75.75 0 1 1-1.499 0v-.5H3.125c-.76 0-1.375-.616-1.375-1.375V9.375a.75.75 0 1 1 1.499 0v.565c.16-.041.328-.065.5-.065h.501V5c0-.76.615-1.375 1.375-1.375h8.75ZM3.75 11.375a.5.5 0 0 0-.501.5v1.75H9.25v-1.75a.5.5 0 0 0-.5-.5h-5Zm7.5 0a.5.5 0 0 0-.501.5v1.75h6.001v-1.75a.5.5 0 0 0-.5-.5h-5Zm-5.501-1.5h3c.474 0 .908.165 1.25.44.343-.275.777-.44 1.25-.44h3.001v-4.75H5.749v4.75Z"
    />
  </svg>
)

export default SvgSofaBed
